import React from "react";
import Nav from "./Nav";
import { Carousel } from "antd";

const Technologies = () => {
  return (
    <>
      <main id="main" className="bg-img">
        <div id="bgImg">
          <div className="container">
            <Nav />

            <div className="content">
              <span>TECHNOLOGY STACK</span>
              <h1>TECHNOLOGY STACK</h1>

              <Carousel autoplay autoplaySpeed={5000}>
                <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    WEB DEVELOPMENT
                  </h2>
                  <p className="ms-0 my-0">
                    Next js: a React framework for building server-rendered
                    applications.
                  </p>
                  <p className="ms-0 my-0">
                    React js: a JavaScript library for building user interfaces.
                  </p>
                  <p className="ms-0 my-0">
                    Typescript:a superset of JavaScript which can help catch
                    errors early during development.
                  </p>
                  <p className="ms-0 my-0">
                    Node and express js:that allows you to execute JavaScript
                    code server-side.
                  </p>
                  <p className="ms-0 my-0">
                    Python flask:a micro web framework for Python used to build
                    web applications.
                  </p>
                  <p className="ms-0 my-0">
                    Redux toolkit:a package that simplifies the process of
                    managing state on the web.
                  </p>
                  <p className="ms-0 my-0">
                    Mui, Ant Design (antd) and tailwind: UI component libraries.
                  </p>
                </div>
                <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    Mobile Application Development
                  </h2>
                  <p className="ms-0 my-0">
                    Flutter: a UI toolkit from Google for building natively
                    compiled applications for mobile, web, and desktop from a
                    single codebase.
                  </p>
                  <p className="ms-0 my-0">
                    Node and express js:that allows you to execute JavaScript
                    code server-side.
                  </p>
                  <p className="ms-0 my-0">
                    MySql:a popular open-source relational database management
                    system (RDBMS).
                  </p>
                </div>
                <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    UX, UI DESIGN
                  </h2>
                  <p className="ms-0">
                    Crafting seamless user experiences and stunning user
                    interfaces, PERFECT leverages Adobe XD to bring your digital
                    vision to life. We specialize in designing intuitive
                    interfaces that prioritize user engagement and satisfaction.
                    Partner with us to create visually captivating and
                    user-friendly experiences that elevate your brand and drive
                    results.
                  </p>
                </div>
                {/* <div>
                  <h2 className="fs-5" style={{ color: "#FFDC64" }}>
                    Emerging Technologies
                  </h2>
                  <p className="ms-0">AI with python flask</p>
                </div> */}
              </Carousel>
            </div>

            <div className="social-media mt-5">
              <a href="https://www.facebook.com/Perfect-151150445074122">
                <img src="img/facebook.png" />
              </a>
              <a href="https://www.instagram.com/perfect94446783/?fbclid=IwAR14fVz3P2rQ5x8Y8sAlERhd1ldCJhGDPt8M1KAoDsH3sO-y_vDRKNy4Yqg">
                <img src="img/instagram.png" />
              </a>
              <a href="https://www.youtube.com/channel/UC-RBwShQdGVl8aQCo2tyHnA/featured">
                <img src="img/youtube.png" />
              </a>

              <span>SOCIAL MEDIA</span>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default Technologies;
